// extracted by mini-css-extract-plugin
module.exports = {"container":"Procedures_container__2yunN","steps":"Procedures_steps__2XYoH"};